// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Sarabun_375f0f', '__Sarabun_Fallback_375f0f'","fontStyle":"normal"},"className":"__className_375f0f","variable":"__variable_375f0f"};